// extracted by mini-css-extract-plugin
export default {"main":"EstadoCajaSelector_main__p1Ppk"};